import styled from 'styled-components';

export const Container = styled.div`
  width: 292px;
  height: 230px;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 8px 14px rgba(0, 0, 0, 0.09);
  border-radius: 4px;

  flex-wrap: wrap;

  padding: 16px 20px 12px 22px;
`;

export const IconContent = styled.div`
  width: 65px;
  height: 65px;
  background: rgba(145, 216, 246, 0.22);
  border-radius: 50%;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > svg path {
    stroke: ${({ theme }) => theme.colors.tertiary};
  }
`;

export const CardInfoContent = styled.div`
  flex-direction: column;

  > h3 {
    font-weight: 500;
    font-size: 24px;
    line-height: 120%;
    color: black;

    margin-top: 8px;
  }

  > p {
    font-size: 14px;
    line-height: 120%;
    color: ${({ theme }) => theme.colors.textSecondary};

    margin-top: 21px;
  }
`;
